module.exports = __webpack_public_path__ + "static/media/comment_act.f963b8bf.svg";